import type { DpiaRequestStatus } from 'config/api/dpiaRequests/dpiaRequests.types';

export type AssetRopaDpiaIndicationFilter = '' | 'true' | 'false';

export type AssetRopaDpiaRequestStatusFilter = '' | Exclude<DpiaRequestStatus, 'cancelled'>;

export type DpiaLifecycleStatusFilterValue = 'draft' | 'in_progress' | 'ready_for_review' | 'clarification_requested' | 'decision_made';

export type AssetRopaDpiaLifecycleStatusFilter = '' | DpiaLifecycleStatusFilterValue;

export type AssetRopaDpiaFilterFields = {
  dpiaIndication: AssetRopaDpiaIndicationFilter;
  dpiaRequestStatus: AssetRopaDpiaRequestStatusFilter;
  dpiaStatus: AssetRopaDpiaLifecycleStatusFilter;
};

export const DEFAULT_ASSET_ROPA_DPIA_FILTER_FIELDS: AssetRopaDpiaFilterFields = {
  dpiaIndication: '',
  dpiaRequestStatus: '',
  dpiaStatus: '',
};

export const DPIA_REQUEST_STATUS_FILTER_VALUES: Exclude<DpiaRequestStatus, 'cancelled'>[] = [
  'draft',
  'decided_dpia_required',
  'decided_dpia_not_required',
];

export const DPIA_LIFECYCLE_STATUS_FILTER_VALUES: DpiaLifecycleStatusFilterValue[] = [
  'draft',
  'in_progress',
  'ready_for_review',
  'clarification_requested',
  'decision_made',
];

export const isDpiaIndicationYes = (dpiaIndication: AssetRopaDpiaIndicationFilter): boolean => dpiaIndication === 'true';

export const clearDependentDpiaFilters = <T extends AssetRopaDpiaFilterFields>(filters: T): T => {
  if (!isDpiaIndicationYes(filters.dpiaIndication)) {
    return {
      ...filters,
      dpiaRequestStatus: '',
      dpiaStatus: '',
    };
  }

  return filters;
};

export const appendDpiaFilterQueryParams = <T extends Record<string, unknown>>(
  params: T,
  filters: AssetRopaDpiaFilterFields,
): T & { dpia_indication?: boolean; dpia_request_status?: string; dpia_status?: string } => {
  let dpiaIndication: boolean | undefined;
  if (filters.dpiaIndication === 'true') {
    dpiaIndication = true;
  } else if (filters.dpiaIndication === 'false') {
    dpiaIndication = false;
  }

  return {
    ...params,
    ...(dpiaIndication !== undefined ? { dpia_indication: dpiaIndication } : {}),
    ...(isDpiaIndicationYes(filters.dpiaIndication) && filters.dpiaRequestStatus ? { dpia_request_status: filters.dpiaRequestStatus } : {}),
    ...(isDpiaIndicationYes(filters.dpiaIndication) && filters.dpiaStatus ? { dpia_status: filters.dpiaStatus } : {}),
  };
};
